import PCheckbox from './src/checkbox';

/* istanbul ignore next */
PCheckbox.install = function (Vue) {
    Vue.component(PCheckbox.name, PCheckbox);
};

export default PCheckbox;
